import styled from 'styled-components';
import React from 'react';
import Icon from '../icons/Icon';
import {Localize} from '../locale/localization';
import {media,mediaMax} from '../utils/uiSizes';

const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	color: white;
	font-family: FyranSans-Core;
	font-weight: 350;
	font-size: 0.875rem;
	letter-spacing: 0.1em;
	line-height: 1em;
	text-transform: uppercase;

	svg {
		fill: white;
		stroke: none;
    	margin-top: 0rem;
		margin-bottom: 0rem;
    	margin-right: 1rem;
	}

	span {
		font-family: FyranSans-Core;
		font-weight: 350;
		display: block;
		width:120px;
	}
	${mediaMax.phone`
	flex-direction: column;
	span {
		padding-top:0.5rem;
	}
	`}
	${media.tablet`
		span {
			display: inherit;
		}
	`}
`;

export const LogoMtv = (props) => {
	const {
		withByline = true,
	} = props;
	return (
		<Container {...props}>
			<Icon icon="#mtv" style={{scale:10}} width="46px" height="46px" />
			{withByline && (
				<span>{Localize('logo.byline')}</span>
			)}
		</Container>
	);
};
export const DarkLogoMtv = (props) => {
	const {
		withByline = true,
	} = props;
	return (
		<Container {...props}>
			<Icon icon="#mtv-dark" style={{scale:10}} width="50px" height="50px" />
			{withByline && (
				<span>{Localize('logo.byline')}</span>
			)}
		</Container>
	);
};
export default LogoMtv;



// WEBPACK FOOTER //
// ./src/ui/LogoMtv.js